import PatientDetails from "pages/patientDetails";
import Patients from "pages/patients";
import ClaimCodingOptimization from "pages/provider/claimCodingOpt";
import EncounterCoding from "pages/provider/encounterCoding";
import AiChat from "pages/scribe/aiChat";
import DictationSummary from "pages/scribe/dictationSummary";
import ScribeAppointments from "pages/provider/Appointments";
import ScribeDashboard from "pages/scribe/Appointments";
import ScribeAddDoctor from "pages/scribe/AddDoctor";
import ScribeHelp from "pages/scribe/Help";
import ScribeProfile from "pages/scribe/Profile";
import Reports from "pages/reports/Reports";
import ScribeSetting from "pages/scribe/Setting";
import StatusList from "pages/scribe/StatusList";
import Dictated from "pages/scribe/Dictated";
import Dictations from "pages/scribe/Dictations";
import RiskAdjustment from "pages/scribe/riskAdjustment";
import CPTOptimizerTool from "pages/scribe/cptOptimizerTool";
import Summary from "pages/scribe/summary";
import ScriberChatting from "pages/provider/scriberChat";
import PreCharting from "pages/scribe/preCharting";
import DictationFrame from "pages/scribe/dictationFrame";
import CareManagement from "pages/scribe/careManagement";

const scribeRoutes = [
  {
    path: "/scribe-dashboard",
    isExact: true,
    component: ScribeDashboard,
  },
  {
    path: "/scriber-chat",
    isExact: false,
    component: ScriberChatting,
  },
  {
    path: "/scribe-appointments",
    isExact: true,
    component: ScribeAppointments,
  },
  {
    path: "/scribe-add-doctor",
    isExact: false,
    component: ScribeAddDoctor,
  },
  {
    path: "/scribing-summary",
    isExact: false,
    component: Summary,
  },
  {
    path: "/scribe-dictations",
    isExact: false,
    component: Dictations,
  },
  {
    path: "/scribe-dictations-summary",
    isExact: false,
    component: DictationSummary,
  },
  {
    path: "/scribe-profile",
    isExact: false,
    component: ScribeProfile,
  },
  {
    path: "/reports",
    isExact: false,
    component: Reports,
  },
  {
    path: "/scribe-help",
    isExact: false,
    component: ScribeHelp,
  },
  {
    path: "/scribe-setting",
    isExact: false,
    component: ScribeSetting,
  },
  {
    path: "/scribe-status-list",
    isExact: false,
    component: StatusList,
  },
  {
    path: "/scribe-notes-details/:data",
    isExact: false,
    component: Dictated,
  },
  {
    path: "/patients",
    isExact: false,
    component: Patients,
  },
  {
    path: "/patients-details/:data",
    isExact: false,
    component: PatientDetails,
  },
  {
    path: "/claim-coding-optimization",
    isExact: false,
    component: ClaimCodingOptimization,
  },
  {
    path: "/encounter-coding",
    isExact: false,
    component: EncounterCoding,
  },
  {
    path: "/encounter-new/:data",
    isExact: false,
    component: PreCharting,
  },
  {
    path: "/risk-adjustment-modeling",
    isExact: false,
    component: RiskAdjustment,
  },
  {
    path: "/cpt-optimizer-tool",
    isExact: false,
    component: CPTOptimizerTool,
  },
  {
    path: "/ai-chat",
    isExact: false,
    component: AiChat,
  },
  {
    path: "/new-scribe-dictations",
    isExact: false,
    component: DictationFrame,
  },
  {
    path: "/care-management",
    isExact: false,
    component: CareManagement,
  },
];

export default scribeRoutes;
